import { useState, useEffect } from 'react';

/**
 * Example: ["meta", "k"], ["ctrl", "shift", "Enter"], ["alt", " "], "Escape"
 */
function useGlobalHotKey(_combo, callback) {
    const [isActive, setIsActive] = useState(false);
    const combo = Array.isArray(_combo) ? _combo : [_combo];
    const isDisabled = !combo || combo.length === 0 || _combo === undefined;
    useEffect(() => {
        const handler = (event) => {
            if (isDisabled) {
                return;
            }
            const pressedKey = event.key === ' ' ? 'Space' : event.key;
            const needCtrl = combo.some((k) => k?.toLowerCase() === 'ctrl');
            const needMeta = combo.some((k) => k?.toLowerCase() === 'meta');
            const needShift = combo.some((k) => k?.toLowerCase() === 'shift');
            const needAlt = combo.some((k) => k?.toLowerCase() === 'alt');
            const mainKey = combo.find((k) => !['ctrl', 'meta', 'shift', 'alt'].includes(k?.toLowerCase() ?? '-'));
            const match = !!needCtrl === event.ctrlKey &&
                !!needMeta === event.metaKey &&
                !!needShift === event.shiftKey &&
                !!needAlt === event.altKey &&
                (!mainKey || pressedKey.toLowerCase() === mainKey.toLowerCase());
            if (match) {
                event.preventDefault();
                if (callback) {
                    callback(event); // callback mode
                }
                else {
                    setIsActive(true); // state mode
                    setTimeout(() => setIsActive(false), 100); // reset
                }
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [combo, callback]);
    return [isActive];
}

export { useGlobalHotKey };
//# sourceMappingURL=useGlobalHotKey.js.map
